module.exports = __webpack_public_path__ + "static/img/image003.abdd670a.png";